import React from 'react';

export const TextBar = () => (
    <path d='M17,23h-1.5c-1.93,0-3.5-1.57-3.5-3.5V16h2c0.276,0,0.5-0.224,0.5-0.5S14.276,15,14,15h-2V4.5C12,2.57,13.57,1,15.5,1H17
		c0.276,0,0.5-0.224,0.5-0.5S17.276,0,17,0h-1.5c-1.739,0-3.251,0.992-4,2.439C10.751,0.992,9.239,0,7.5,0H6
		C5.724,0,5.5,0.224,5.5,0.5S5.724,1,6,1h1.5C9.43,1,11,2.57,11,4.5V15H9c-0.276,0-0.5,0.224-0.5,0.5S8.724,16,9,16h2v3.5
		c0,1.93-1.57,3.5-3.5,3.5H6c-0.276,0-0.5,0.224-0.5,0.5S5.724,24,6,24h1.5c1.739,0,3.251-0.992,4-2.439
		c0.749,1.447,2.261,2.439,4,2.439H17c0.276,0,0.5-0.224,0.5-0.5S17.276,23,17,23z' />
);
